import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class OvelhinhasProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  private instituicaoFiltragem = null;

  constructor(public http: HttpClient) {}

  getLayoutListagem() {
    return this.http.get<any>(this.baseUrl + "/ovelhinhas/get-layout-listagem", {}).pipe(
      map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      })
    );
  }

  getFamiliares(isImprimir: boolean, idade: any, idInstituicaoFiltro: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/get-familiares", {
        isImprimir: isImprimir,
        idade: idade,
        idInstituicaoFiltro: idInstituicaoFiltro,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  updatePessoa(pessoa: any) {
    return this.http.post<any>(this.baseUrl + "/ovelhinhas/update-pessoa", { pessoa: pessoa }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  removerFamiliar(idPessoa: any) {
    return this.http.post<any>(this.baseUrl + "/ovelhinhas/remover-familiar", { idPessoa: idPessoa }).pipe(
      map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      })
    );
  }

  inscreverReuniao(idPessoa: any, familiares: any, apiToken: string, idInstituicaoFiltro: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/inscrever-reuniao", {
        idPessoa: idPessoa,
        familiares: familiares,
        apiToken: apiToken,
        idInstituicaoFiltro: idInstituicaoFiltro,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getOvelhinhas(idInstituicaoFiltro: null) {
    return this.http.get<any>(this.baseUrl + "/ovelhinhas/get-ovelhinhas",
      { 
        params: {
          idInstituicaoFiltro: idInstituicaoFiltro ?? '',
        }
      }
      ).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getOvelhinhasResponsavel() {
    return this.http.get<any>(this.baseUrl + "/ovelhinhas/get-ovelhinhas-responsavel", {
      params: {
        idInstituicaoFiltro: this.getInstituicaoFiltragem() ?? ''
      },
    }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  buscarReunioesOvelhinha(idOvelhinha: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/buscar-reunioes-ovelhinha", { idOvelhinha: idOvelhinha })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getParticipantesReuniao(
    filtro: {
      q: any;
      t: any;
      idReuniao: string | number | boolean | readonly (string | number | boolean)[];
      id: number;
    },
    pag: { currentPage: any }
  ) {
    return this.http
      .get<any>(this.baseUrl + "/ovelhinhas/get-participantes-reuniao", {
        observe: "response",
        params: {
          page: pag.currentPage,
          "per-page": "10",
          q: filtro.q,
          t: filtro.t,
          idReuniao: filtro.idReuniao ? filtro.idReuniao : "",
          id: filtro.id ? filtro.id : "",
        },
      })
      .pipe(
        map((data) => {
          let pag = {
            currentPage: data.headers.get("X-Pagination-Current-Page"),
            pageCount: data.headers.get("X-Pagination-Page-Count"),
            perPage: data.headers.get("X-Pagination-Per-Page"),
            totalCount: data.headers.get("X-Pagination-Total-Count"),
          };
          return {
            pessoas: data.body,
            pagination: pag,
          };
        })
      );
  }

  removerParticipante(idReuniao: any, idPessoa: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/remover-participante", {
        idReuniao: idReuniao,
        idPessoa: idPessoa,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  saidaParticipante(idReuniao: any, participante: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/saida-participante", {
        idReuniao: idReuniao,
        participante: participante,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  addParticipantesReuniao(inscricao: any) {
    return this.http.post<any>(this.baseUrl + "/ovelhinhas/add-participantes-reuniao", { inscricao: inscricao }).pipe(
      map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      })
    );
  }

  salvarVinculoDependentes(responsavel: any, dependentes: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/salvar-vinculo-dependentes", {
        responsavel: responsavel,
        dependentes: dependentes,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  imprimirEtiquetaParticipante(dados: any, apiToken: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/imprimir-etiqueta-participante", {
        dados: dados,
        apiToken: apiToken,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getResponsaveis(idOvelhinha: any) {
    return this.http.post<any>(this.baseUrl + "/ovelhinhas/get-responsaveis", { idOvelhinha: idOvelhinha }).pipe(
      map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      })
    );
  }

  getRunioes(idOvelhinha: any) {
    return this.http.post<any>(this.baseUrl + "/ovelhinhas/get-reunioes", { idOvelhinha: idOvelhinha }).pipe(
      map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      })
    );
  }

  salvarReuniao(idOvelhinha: any, reuniao: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/salvar-reuniao", {
        idOvelhinha: idOvelhinha,
        reuniao: reuniao,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getParticipantesPorReuniao(idOvelhinha: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/get-participantes-por-reuniao", {
        idOvelhinha: idOvelhinha,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  isRegrasOvelhinhas(idReuniao: any, pessoa: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/is-regras-ovelhinhas", {
        idReuniao: idReuniao,
        pessoa: pessoa,
      })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  reCheckIn(idDependente: any, idReuniao: any) {
    return this.http
      .post<any>(this.baseUrl + "/ovelhinhas/re-check-in", {
        idDependente: idDependente,
        idReuniao: idReuniao,
      })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  setInstituicaoFiltragem(instituicao: any) {
    this.instituicaoFiltragem = instituicao;
  }

  getInstituicaoFiltragem() {
    return this.instituicaoFiltragem;
  }
}
